import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import { setModalOpen } from 'shared/slices/modal';
import { setSearchMetaTooltipAvailable } from 'shared/slices/searchMetaTooltip';
import { AllFiltersModalContainer } from './containers';
import { IPreloadedState } from 'shared/types/redux';

export const AllFiltersContainer: FC = () => {
  const dispatch = useAppDispatch();
  const opened = useSelector((state: IPreloadedState) => state.allFiltersModal.isOpen);

  const onClose = useCallback(() => {
    dispatch(setModalOpen(false));
    dispatch(setSearchMetaTooltipAvailable(true));
  }, [dispatch]);

  if (!opened) {
    return null;
  }

  return <AllFiltersModalContainer onClose={onClose} />;
};
